import type { DocumentTypeDatabase } from '../../../../types';

type Props = {
  type: DocumentTypeDatabase;
  onEdit: (type: DocumentTypeDatabase) => void;
  onDelete: (type: DocumentTypeDatabase) => void;
};

export default function useDocumentTypeMenuAction(props: Props) {
  function handleEdit() {
    props.onEdit(props.type);
  }

  function handleDelete() {
    props.onDelete(props.type);
  }

  return {
    handleEdit,
    handleDelete,
  };
}
